import React from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import { useLayoutContext } from "../../Contexts/LayoutContext";
import Fidelity from "../Fidelity";

const ProfileFidelity = () => {
    document.title = "Pontos de Fidelidade";

    const { currentStore } = useStoreContext();
    const { company } = useLayoutContext();

    if (!company?.fidelity?.active) return null;

    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>
                <Fidelity showHeader={false} />
            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileFidelity;
